import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { accessTokenKey, baseUrl, addOrUpdateURLParam } from "../utils/config";

import Loader from "./layouts/Loader";

function Users() {
    let urlSearchParams = new URLSearchParams(window.location.search);

    const [loading, setLoading] = useState(false);
    const [users, setUsers] = useState([]);
    const [timer, setTimer] = useState(null);
    const [page, setPage] = useState(urlSearchParams.get("page") || 1);
    const [pages, setPages] = useState(0);
    const [total, setTotal] = useState(0);
    const [refetch, setRefetch] = useState(1);
    const [search, setSearch] = useState("");

    async function fetch() {
        setLoading(true);

        try {
            const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const formData = new FormData();
            formData.append("time_zone", timeZone);
            formData.append("page", page);
            formData.append("search", search);
            formData.append("type", "job_seeker");

            const response = await axios.post(
                baseUrl + "/api/users/fetch",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                setUsers(response.data.users);
                setTotal(response.data.total);
                setPages(response.data.pages);
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setLoading(false);
        }
    }

    useEffect(function () {
        fetch();
    }, [refetch]);

    const styles = {
        total: {
            fontSize: "18px"
        }
    };

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Find talent</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Find talent</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl">
                <div className="container">

                    { loading && (
                        <div className="row mb-5">
                            <div className="col-md-12 text-center">
                                <Loader />
                            </div>
                        </div>
                    ) }

                    <div className="row mb-5">
                        <div className="offset-md-4 col-md-4">
                            <input type="text" className="form-control" placeholder="Search..."
                                onChange={ function (e) {
                                    clearTimeout(timer);
                                    setSearch(e.target.value);

                                    setTimer(setTimeout(function () {
                                        setRefetch(refetch + 1);
                                    }, 500));
                                } }
                                value={ search } />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <p className="ms-4" style={ styles.total }>
                                Total&nbsp;
                                <span className="bold">{ total }</span> user{ total > 1 ? "s" : "" } found.
                            </p>
                        </div>

                        { users.map(function (u, index) {
                            return (
                                <div className="col-md-4" key={ `user-${ index }` }>
                                    <div className="user-cards">
                                        <div className="user-card">
                                            <img className="user-card__image" src={ u.profile_image }
                                                alt={ u.name }
                                                onError={ function (event) {
                                                    event.target.remove();
                                                } } />
                                            
                                            <div className="user-card__info">
                                                <h2 className="user-card__name">{ u.name }</h2>
                                                
                                                { u.about != "" && (
                                                    <p className="user-card__title">{ u.about }</p>
                                                ) }

                                                <p className="user-card__location mb-2">{ u.currently_working == "" ? "" : ((u.currently_working || "") + " - ") } { u.currently_located }</p>
                                                
                                                { u.email && (
                                                    <p>{ u.email }</p>
                                                ) }

                                                <div className="user-card__actions">
                                                    <Link to={ `/user/${ u.id }` } className="user-card__button">Profile</Link>
                                                    {/*<button className="user-card__button user-card__button--outline">Message</button>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        }) }

                        { pages > 1 && (
                            <nav className="ms-3">
                                <ul className="pagination">
                                    { Array.from({ length: pages }, function (_, index) { return index + 1 } ).map(function (p) {
                                        return (
                                            <li key={ `pagination-${ p }` } className={ `page-item ${ p == page ? "active" : "" }` }>
                                                <a href="#" className="page-link" onClick={ function (event) {
                                                    event.preventDefault();
                                                    setPage(p);
                                                    setRefetch(refetch + 1);
                                                    addOrUpdateURLParam("page", p);
                                                } }>{ p }</a>
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </nav>
                        ) }
                    </div>
                </div>
            </div>
        </>
    );
}

export default Users;